<script>
    import { mysteryItems } from '../../store.js';
    let settingItems = $mysteryItems;
</script>


<h1 style="text-align:center">상황판</h1>

<table id="customers">
    <tr>
      <th>index</th>
      <th>이름</th>
      <th>이미지</th>
      <th>남은수량</th>
      <th>확률</th>
    </tr>     
    {#each $mysteryItems as item, i}
    <tr> 
        <td>{i+1}</td>
        <td>{item.name}</td>
        <td><img src={item.image} /></td>
        <td>{item.quantity}</td>
        <td>{Number(item.quantity/$mysteryItems.reduce((total, next) => total + next.quantity, 0)*100).toFixed(2)}%</td>
    </tr>
    {/each}
    
  </table>


<style>
    img {
        width: 30%;
    }
    table {
        width: 100%;
        border: 1px solid #444444;
        border-collapse: collapse;
    }
    th, td {
        border: 1px solid #444444;
        padding: 10px;
    }
    .row {
        border: 1px solid black;
    }
    .content {
      display: grid;
      grid-template-columns: 20% 80%;
      grid-column-gap: 10px;
    }

    .content img {
        width: 200px;
        object-fit: contain;
    }
</style>

